import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Pagination,
    CircularProgress,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useHistorial } from "../../../hooks/administration/useServiceOrders";

const itemsPerPage = 20;

const ServiceHistory = () => {
    const { serviceId } = useParams();
    const { historial, isLoading, error } = useHistorial(serviceId);
    const [filteredHistory, setFilteredHistory] = useState([]);
    const [filterType, setFilterType] = useState("ALL");
    const [page, setPage] = useState(1);

    useEffect(() => {
        if (filterType === "ALL") {
            setFilteredHistory(historial);
        } else {
            setFilteredHistory(
                historial.filter((event) => event.hisacc.toLowerCase().includes(filterType.toLowerCase()))
            );
        }
        setPage(1); // Reset to first page when filtering
    }, [historial, filterType]);

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Typography color="error">
                Error al cargar el historial: {error.message}
            </Typography>
        );
    }

    const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);
    const paginatedData = filteredHistory.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );

    return (
        <Paper sx={{ p: 3, boxShadow: 3 }}>
            <Typography variant="h6" mb={3}>
                Historial del Servicio (OS-0000{serviceId})
            </Typography>

            {/* Filtros */}
            <Box display="flex" justifyContent="flex-start" mb={3}>
                <FormControl sx={{ minWidth: 220 }}>
                    <InputLabel>Filtrar por tipo</InputLabel>
                    <Select
                        value={filterType}
                        label="Filtrar por tipo"
                        onChange={(e) => setFilterType(e.target.value)}
                    >
                        <MenuItem value="ALL">Todos</MenuItem>
                        <MenuItem value="Creación">Creación</MenuItem>
                        <MenuItem value="Asignó">Asignaciones</MenuItem>
                        <MenuItem value="Estado">Cambio de Estado</MenuItem>
                        <MenuItem value="Viajeros">Viajeros</MenuItem>
                    </Select>
                </FormControl>
            </Box>

            {/* Tabla de historial */}
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                            <TableCell><strong>Fecha</strong></TableCell>
                            <TableCell><strong>Usuario</strong></TableCell>
                            <TableCell><strong>Acción</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedData.map((event) => (
                            <TableRow key={event.hisid}>
                                <TableCell>{new Date(event.credat).toLocaleString()}</TableCell>
                                <TableCell>{`${event.nomusu}`}</TableCell>
                                <TableCell>{event.hisacc}</TableCell>
                            </TableRow>
                        ))}
                        {paginatedData.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={3} align="center">
                                    No se encontraron registros.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Paginación */}
            {totalPages > 1 && (
                <Box display="flex" justifyContent="center" mt={3}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(_, value) => setPage(value)}
                        color="primary"
                    />
                </Box>
            )}
        </Paper>
    );
};

export default ServiceHistory;
